<template>
  <div class="DRecommend inner_center">
    <DRecommendHot v-bind="$attrs"/>
    <DRecommendTopic v-bind="$attrs"/>
  </div>
</template>

<script>
import DRecommendHot from '@/components/3d/d-recommend/d-recommend-hot'
import DRecommendTopic from '@/components/3d/d-recommend/d-recommend-topic'
export default {
  name: "DRecommend",
  components:{
    DRecommendHot,
    DRecommendTopic,
  }
}
</script>

<style lang="scss" scoped>
.DRecommend{
  display: flex;
  //align-items: center;
  margin-bottom: 72px;
  justify-content: space-between;
  position: relative;
  z-index: 3;
}
</style>
